import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "src/app/config";

const initialState = {
  company: {},
  companyVehicleList: [],

  isOnboardCompanyLoading: false,
  isOnboardCompanyError: false,
  isOnboardCompanySuccess: false,
  onboardCompanyError: null,

  isAddCompanyToUserLoading: false,
  isAddCompanyToUserError: false,
  isAddCompanyToUserSuccess: false,
  addCompanyToUserError: null,

  isCompanyVehicleLoading: false,
  isCompanyVehicleError: false,
  isCompanyVehicleSuccess: false,
  CompanyVehicleError: null,
};

export const onboardCompany = createAsyncThunk(
  "company/onboardCompany",
  async (thunkAPI, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    try {
      const { token, formData } = thunkAPI ?? {};
      const response = await axiosApi({ token }).post(
        `/company/onboardCompany`,
        {
          ...formData,
        }
      );
      return fulfillWithValue(JSON.parse(JSON.stringify(response.data)));
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCompanyToUser = createAsyncThunk(
  "company/addCompanyToUser",
  async (thunkAPI, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    try {
      const { token, formData } = thunkAPI ?? {};
      const response = await axiosApi({ token }).post(
        `/company/addCompanyToUser`,
        {
          ...formData,
        }
      );
      return fulfillWithValue(JSON.parse(JSON.stringify(response.data)));
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCompanyVehicle = createAsyncThunk(
  "company/getCompanyVehicle",
  async (thunkAPI, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    try {
      const { token, companyId } = thunkAPI ?? {};
      const response = await axiosApi({ token }).post(
        `/company/getCompanyVehicle`,
        {
          companyId,
        }
      );
      return fulfillWithValue(JSON.parse(JSON.stringify(response.data)));
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    clearSuccess: (state) => {
      state.isOnboardCompanySuccess = false;
      state.isOnboardCompanyError = false;
      state.isOnboardCompanyLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(onboardCompany.pending, (state) => {
      state.isOnboardCompanyLoading = true;
    });
    builder.addCase(onboardCompany.fulfilled, (state, action) => {
      state.isOnboardCompanyLoading = false;
      state.isOnboardCompanySuccess = true;
    });
    builder.addCase(onboardCompany.rejected, (state, action) => {
      state.isOnboardCompanyLoading = false;
      state.onboardCompanyError = action.payload.error;
      state.isOnboardCompanyError = true;
    });

    builder.addCase(addCompanyToUser.pending, (state) => {
      state.isAddCompanyToUserLoading = true;
    });
    builder.addCase(addCompanyToUser.fulfilled, (state, action) => {
      state.isAddCompanyToUserLoading = false;
      state.isAddCompanyToUserSuccess = true;
    });
    builder.addCase(addCompanyToUser.rejected, (state, action) => {
      state.isAddCompanyToUserLoading = false;
      state.addCompanyToUserError = action.payload.error;
      state.isAddCompanyToUserError = true;
    });

    builder.addCase(getCompanyVehicle.pending, (state) => {
      state.isCompanyVehicleLoading = true;
    });
    builder.addCase(getCompanyVehicle.fulfilled, (state, action) => {
      state.isCompanyVehicleLoading = false;
      state.isCompanyVehicleSuccess = true;
      state.companyVehicleList = action.payload?.data;
    });
    builder.addCase(getCompanyVehicle.rejected, (state, action) => {
      state.isCompanyVehicleLoading = false;
      state.CompanyVehicleError = action.payload.error;
      state.isCompanyVehicleError = true;
    });
  },
});

export const { clearSuccess } = companySlice.actions;
export default companySlice.reducer;
